import { render, staticRenderFns } from "./problem_form.vue?vue&type=template&id=060ab4a0&"
import script from "./problem_form.vue?vue&type=script&lang=js&"
export * from "./problem_form.vue?vue&type=script&lang=js&"
import style0 from "./problem_form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports